module.exports = __webpack_public_path__ + "static/media/snowflake-gray.10e2dde9.svg";